import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { injectIntl, FormattedMessage } from 'react-intl';
import ModalDialog from '@tine/lib-frontend-components/components/dialogs/modal-dialog';
import ConfirmDialogBox from 'components/ConfirmDialogBox';
import { AlertIcon } from '@tine/lib-frontend-components/elements/icons';
import ActionButton from '@tine/lib-frontend-components/components/buttons/action-button';
import { reduxForm } from 'redux-form';
import { SetSessionData, GetSessionData } from 'utils';
import { isMobileOnly } from 'react-device-detect';

import ProfileImage from 'components/ProfileImage';
import TaskListItem from 'mui-mobile-components/tasks/tasklist/TaskListItem';
import {
  fetchTaskList,
  createUpdateTask,
  taskListSortByOption,
  deleteTasks,
  deleteInfoClear,
  selectedTaskCompleted,
} from 'actions/Tasks';

import exportReport from 'actions/Reports';
import Loader from 'components/Loader';
import {
  TaskSortingOptions,
  ActivityTranslation,
} from 'constants/DropdownAndTranslationOptions';
import {
  UNDEFINED,
  COMPLETED,
  CREATE_TASKS,
  UPDATE_TASK,
  DELETE_TASK,
  FILTER_TASK_FIELD,
  FILTER_TASK_STATUS,
  FILTER_TASK_ACTIVITY,
  FILTER_TASK_YEAR,
  FILTER_TASK_CUT,
  FILTER_TASK_SEASON
} from 'constants/index';
import { getUsers } from 'actions/Users';
import { checkPermissions } from 'utils/index';
import { TASK_PERIOD_VALUE } from 'constants/store/Tasks';
import { Dialog, DialogTitle, Stack, Box, Chip, Button, Typography, List, ListItem, Checkbox, CircularProgress, IconButton, Fab } from '@mui/material';
import { PlusIcon } from 'components/mui-forms/MuiIcons';
import { ADD_FIELD, ADD_TASK } from 'constants/MixPanel';
import mixpanel from 'mixpanel-browser';
import { buttonRoundStyle, buttonStyle } from 'mui-components/fields/fertilization/services/fertilizationStyles';
import EditTask from './EditTask';
import NewAddTaskModalWindow from './NewAddTaskModalWindow';
import * as fieldActions from 'actions/Fields';
import * as fieldListStyle from '../../fields/fieldtab/FieldListStyle';
import { createSvgIcon } from '@mui/material/utils';
import * as getUserActivitiesAction from 'actions/UserActivities';
import BottomSheet from './BottomSheet';
import Snackbar from '@mui/material/Snackbar';
import MuiMultiSelectBottomSheet from '../MuiMultiSelectBottomSheet';
import MuiMultiSelectListBottomSheet from '../MuiMultiSelectListBottomSheet';
import * as taskTemplateStyle from '../../kart/fieldmap/tasktemplates/TaskTemplateStyle';

const dialogTitleDialogStyle = { color: '#191C1C', fontFamily: 'Inter', fontSize: '24px', fontStyle: 'normal', fontWeight: '400', lineHeight: '32px' }
const dialogSubTitleStyle = { color: '#3F4949', fontFamily: 'Inter', fontSize: '14px', fontStyle: 'normal', fontWeight: '400', lineHeight: '20px', letterSpacing: '0.25px', padding: '10px 24px' }

class ManageTask extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkedItems: new Map(),
      assignee: '',
      assigeUpdateConfirm: false,
      deleteConfirmShow: false,
      selectedAssigneeData: {},
      hasCompletedTask: false,
      assignOnlyCompletedTask: false,
      clearSelection: false,
      hasPermission: {
        createTask: false,
        deletetask: false,
        updateTask: false
      },
      displayFilter: false,
      displayMultiple: true,
      taskListFields: [],
      taskListStatuses: [],
      taskListActivities: [],
      filterChange: false,
      fetchTaskDetails: true,
      resetFilter: false,
      completedTaskState: false,
      deleteTaskState: false,
      show: false,
      editTask: false, // open and close EditTask 
      filteredTask: [],
      openNewAddTaskModalWindow: false,
      selectedActivityId: null,
      selectedFieldId: null,
      selectedActivityName: null,
      selectedFieldName: null,
      panelLeft: 0,
      panelWidth: 0,
      selectedItems: [],
      isBottomSheetVisible: false,
      showSnackBar: false,
      snackbarMessage: '',
      selectedItemsCountForSnackbar: 0,
      isExporting: false,
      selectAll: false,
      isModalOpen: false
    };
    this.tabPanelRef = React.createRef();
    this.handleFilterFieldChange = this.handleFilterFieldChange.bind(this);
    this.handleFilterTaskChange = this.handleFilterTaskChange.bind(this);
    this.handleOpenModalWindow = this.handleOpenModalWindow.bind(this);
    this.handleCloseModalWindow = this.handleCloseModalWindow.bind(this);
    this.handleOpenNewAddTaskModalWindow = this.handleOpenNewAddTaskModalWindow.bind(this);
    this.handleCloseNewAddTaskModalWindow = this.handleCloseNewAddTaskModalWindow.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.resetFilter = this.resetFilter.bind(this);
  }

  updateSelectedItemsCountForSnackbar = () => {
    this.setState({ selectedItemsCountForSnackbar: this.state.selectedItems.length });
  };

  componentDidMount = () => {
    if (this.tabPanelRef.current) {
      this.tabPanelRef.current.addEventListener('scroll', this.handleScroll);
    }
    const {
      activeFarm,
      userDetails,
      fetchAssignee,
      assignees,
      farmsData,
      history,
      taskList,
      fetchFieldList1,
      getUserActivities
    } = this.props;

    if (activeFarm) {
      const fieldValue = this.filterValueList("field");
      const taskValue = this.filterValueList("task");
      const yearValue = this.filterValueList("year");
      const cutValue = this.filterValueList("cut");
      const seasonValue = this.filterValueList("season");
      this.updatePanelPosition();
      window.addEventListener('resize', this.updatePanelPosition);
      fetchFieldList1(activeFarm.farm.id);
      getUserActivities(activeFarm.farm.id);

      if ((fieldValue && fieldValue.length > 0) ||
        (taskValue && taskValue.length > 0) || (yearValue && yearValue.length > 0) || (cutValue && cutValue.length > 0) || (seasonValue && seasonValue.length > 0)) {
        this.setState({ filterChange: true, displayFilter: true });
      } else {
        this.setState({ filterChange: false, displayFilter: false });
      }

      let taskCount;
      const formattedYearsForAPI = yearValue && yearValue.length > 0 ? yearValue.join(',') : [9999];

      if (taskList.taskListPositionInfo.fromTask && taskList.data) {
        taskCount = taskList.data.length;
        this.fetchList(
          0,
          taskCount < 15 ? 15 : taskCount,
          formattedYearsForAPI,
          taskValue,
          fieldValue,
          cutValue,
          seasonValue
        );
      } else {
        // this.fetchList(
        //   0,
        //   15,
        //   formattedYearsForAPI,
        //   taskValue,
        //   fieldValue,
        //   cutValue,
        //   seasonValue
        // );
      }
      if (!assignees.users) {
        fetchAssignee(activeFarm.farm.id, userDetails.idToken);
      }
      this.updatePermission();
    }
    if (farmsData && !farmsData.isLoading && farmsData.data && farmsData.data.length < 1) {
      history.push('/managefields');
    }
  };

  componentWillUnmount() {
    window.removeEventListener('resize', this.updatePanelPosition);
    if (this.tabPanelRef.current) {
      this.tabPanelRef.current.removeEventListener('scroll', this.handleScroll);
    }
  }

  handleScroll = (() => {
    let ticking = false;

    return () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const container = this.tabPanelRef.current;
          if (!container) return;

          const scrollTop = container.scrollTop;
          const scrollHeight = container.scrollHeight;
          const clientHeight = container.clientHeight;

          const nearBottom = scrollTop + clientHeight >= scrollHeight - 150;

          const { taskList } = this.props;
          const { isLoading, isDeleteLoading, data, paginationDetails } = taskList;

          const totalFilteredCount = paginationDetails?.totalTaskCount || 0;
          const currentDataCount = data?.length || 0;

          const hasMore = currentDataCount < totalFilteredCount;

          if (nearBottom && !isLoading && !isDeleteLoading && hasMore) {
            this.fetchMoreTask();
          }

          ticking = false;
        });

        ticking = true;
      }
    };
  })();

  componentDidUpdate(prevProps) {
    const { intl, activeFarm, userDetails, fetchAssignee, taskList, taskDetails, fetchFieldList1 } = this.props;
    const { filterChange, fetchTaskDetails, resetFilter, completedTaskState, deleteTaskState, selectedItems } = this.state;

    if (prevProps.activeFarm !== activeFarm) {
      window.location.replace("/#/tasks");
      window.location.reload();
      // Move these lines specifically inside the activeFarm change block
      sessionStorage.removeItem(FILTER_TASK_ACTIVITY);
      sessionStorage.removeItem(FILTER_TASK_FIELD);
      sessionStorage.removeItem(FILTER_TASK_YEAR);
      sessionStorage.removeItem(FILTER_TASK_CUT);
      sessionStorage.removeItem(FILTER_TASK_SEASON);
      return; // Important: Exit early if farm changed to prevent subsequent logic from running on an old farm context
    }

    if (fetchTaskDetails && taskList.data && !taskList.isLoading) {
      this.setState({ taskListFields: taskList.paginationDetails.fields });
      this.setState({ taskListActivities: taskList.paginationDetails.activities });
      this.setState({ fetchTaskDetails: false });
      SetSessionData(FILTER_TASK_STATUS, this.reAssignValueList('status', taskList.paginationDetails.statuses));
      SetSessionData(FILTER_TASK_ACTIVITY, this.reAssignValueList('task', taskList.paginationDetails.activities));
    }

    // Get filter values from session storage for subsequent fetchList calls
    // These should be retrieved AFTER any potential clearing logic, but BEFORE a fetchList call
    // that might need them.
    const fieldValue = resetFilter ? [] : this.filterValueList("field");
    const taskValue = resetFilter ? [] : this.filterValueList("task");
    const yearValue = resetFilter ? [] : this.filterValueList("year");
    const cutValue = resetFilter ? [] : this.filterValueList("cut");
    const seasonValue = resetFilter ? [] : this.filterValueList("season");


    // This block should now only trigger for completion/deletion success
    if (
      (!completedTaskState && taskList.isCompletedSuccess) ||
      (!deleteTaskState && taskList.deleteSuccess)
    ) {
      this.fetchList(
        0,
        15,
        yearValue,      // years
        taskValue,      // activityIds
        fieldValue,     // fieldIds
        cutValue,       // cuts
        seasonValue     // seasons
      );
      fetchAssignee(activeFarm.farm.id, userDetails.idToken);
      fetchFieldList1(activeFarm.farm.id);
      this.setState({
        completedTaskState: true,
        deleteTaskState: true,
      });
      if (!deleteTaskState && taskList.deleteSuccess) {
        const { selectedItemsCountForSnackbar, singleDeletedActivityIdForSnackbar } = this.state;
        let snackbarMessage = '';
        if (selectedItemsCountForSnackbar === 1 && singleDeletedActivityIdForSnackbar !== null) {
          const activityOptions = this.getActivityOptions();
          const matchedActivity = activityOptions.find(option => option.value === singleDeletedActivityIdForSnackbar);
          const activityName = matchedActivity?.label;
          snackbarMessage = `${activityName} ${intl.formatMessage({ id: 'TASKS_DELETED' })}`;
        } else {
          snackbarMessage = `${selectedItemsCountForSnackbar} ${intl.formatMessage({ id: 'TASKS_DELETED' })}`;
        }
        this.setState({
          showSnackBar: true,
          snackbarMessage,
          selectedItemsCountForSnackbar: 0,
          singleDeletedActivityIdForSnackbar: null,
        });
      }
      this.updatePermission();
      this.clearSelection(true);
    }

    if (filterChange) {
      this.fetchList(
        0,
        15,
        yearValue.length === 0 ? [9999] : yearValue,      // years
        taskValue,      // activityIds
        fieldValue,     // fieldIds
        cutValue,       // cuts
        seasonValue     // seasons
      );
      this.setState({ resetFilter: false, filterChange: false });
    }
    if (taskList !== prevProps.taskList) {
      if (this.state.selectAll && taskList.data) {
        const newIds = taskList.data.map((item) => item.id);
        const unseenIds = newIds.filter(id => !this.state.selectedItems.includes(id));

        if (unseenIds.length > 0) {
          this.setState(prevState => ({
            selectedItems: [...prevState.selectedItems, ...unseenIds]
          }));
        }
      }
      this.clearSelection();
    }
    if (taskDetails.isSuccess) {
      this.fetchList(
        0,
        15,
        yearValue,      // years
        taskValue,      // activityIds
        fieldValue,     // fieldIds
        cutValue,       // cuts
        seasonValue     // seasons
      );
    }
  }

  /**
   * to reassign the session data
   * @param {*} fieldFilterValue 
   * @returns 
  */
  reAssignValueList = (fieldFilterValue, taskList) => {
    var fieldValue = [];
    switch (fieldFilterValue) {
      case 'status':
        if (GetSessionData(FILTER_TASK_STATUS) && GetSessionData(FILTER_TASK_STATUS) !== null) {
          if (GetSessionData(FILTER_TASK_STATUS).length > 0) {
            for (let eventValue of GetSessionData(FILTER_TASK_STATUS)) {
              if (eventValue === null || typeof eventValue === 'undefined' ||
                eventValue.value === null || typeof eventValue.value === 'undefined') {
                continue;
              }
              let keyPair = {};
              keyPair['value'] = eventValue.value;
              const foundTask = taskList.filter(opt => opt.id === eventValue.value)[0];
              keyPair['label'] = foundTask ? foundTask['name'] : '';
              fieldValue.push(keyPair);
            }
          }
        }
        return fieldValue;
      case 'task':
        if (GetSessionData(FILTER_TASK_ACTIVITY) && GetSessionData(FILTER_TASK_ACTIVITY) !== null) {
          if (GetSessionData(FILTER_TASK_ACTIVITY).length > 0) {
            for (let eventValue of GetSessionData(FILTER_TASK_ACTIVITY)) {
              if (eventValue === null || typeof eventValue === 'undefined' ||
                eventValue.value === null || typeof eventValue.value === 'undefined') {
                continue;
              }
              let keyPair = {};
              keyPair['value'] = eventValue.value;
              const foundTask = taskList.filter(opt => opt.id === eventValue.value)[0];
              keyPair['label'] = foundTask ? foundTask['activityName'] : '';
              fieldValue.push(keyPair);
            }
          }
        }
        return fieldValue;
      default:
        return fieldValue;
    }
  }

  /**
   * to get the filter values
   * @param {*} fieldFilterValue 
   * @returns 
   */
  filterValueList = (fieldFilterValue) => {
    const { taskList } = this.props;
    var fieldValue = [];
    switch (fieldFilterValue) {
      case 'field':
        if (GetSessionData(FILTER_TASK_FIELD) && GetSessionData(FILTER_TASK_FIELD) !== null) {
          if (GetSessionData(FILTER_TASK_FIELD).length > 0) {
            for (let eventValue of GetSessionData(FILTER_TASK_FIELD)) {
              // Add null/undefined check here
              if (eventValue !== null && typeof eventValue !== 'undefined' && eventValue.value !== null && typeof eventValue.value !== 'undefined') {
                fieldValue.push(eventValue.value);
              }
            }
          }
        }
        return fieldValue;
      case 'status':
        if (GetSessionData(FILTER_TASK_STATUS) && GetSessionData(FILTER_TASK_STATUS) !== null) {
          if (GetSessionData(FILTER_TASK_STATUS).length > 0) {
            for (let eventValue of GetSessionData(FILTER_TASK_STATUS)) {
              // Add null/undefined check here
              if (eventValue !== null && typeof eventValue !== 'undefined' && eventValue.value !== null && typeof eventValue.value !== 'undefined') {
                fieldValue.push(eventValue.value);
              }
            }
          }
        }
        return fieldValue;
      case 'task':
        if (GetSessionData(FILTER_TASK_ACTIVITY) && GetSessionData(FILTER_TASK_ACTIVITY) !== null) {
          if (GetSessionData(FILTER_TASK_ACTIVITY).length > 0) {
            for (let eventValue of GetSessionData(FILTER_TASK_ACTIVITY)) {
              if (eventValue !== null && typeof eventValue !== 'undefined' && eventValue.value !== null && typeof eventValue.value !== 'undefined') {
                fieldValue.push(eventValue.value);
              }
            }
          }
        }
        return fieldValue;
      case 'year':
        if (GetSessionData(FILTER_TASK_YEAR) && GetSessionData(FILTER_TASK_YEAR) !== null) {
          if (GetSessionData(FILTER_TASK_YEAR).length > 0) {
            for (let eventValue of GetSessionData(FILTER_TASK_YEAR)) {
              if (eventValue !== null && typeof eventValue !== 'undefined' && eventValue.value !== null && typeof eventValue.value !== 'undefined') {
                fieldValue.push(eventValue.value);
              }
            }
          }
        } else {
          fieldValue.push(taskList?.paginationDetails?.years[0]);
        }
        return fieldValue;
      case 'cut':
        if (GetSessionData(FILTER_TASK_CUT) && GetSessionData(FILTER_TASK_CUT) !== null) {
          if (GetSessionData(FILTER_TASK_CUT).length > 0) {
            for (let eventValue of GetSessionData(FILTER_TASK_CUT)) {
              if (eventValue !== null && typeof eventValue !== 'undefined' && eventValue.value !== null && typeof eventValue.value !== 'undefined') {
                fieldValue.push(eventValue.value);
              }
            }
          }
        }
        return fieldValue;
      case 'season':
        if (GetSessionData(FILTER_TASK_SEASON) && GetSessionData(FILTER_TASK_SEASON) !== null) {
          if (GetSessionData(FILTER_TASK_SEASON).length > 0) {
            for (let eventValue of GetSessionData(FILTER_TASK_SEASON)) {
              if (eventValue !== null && typeof eventValue !== 'undefined' && eventValue.value !== null && typeof eventValue.value !== 'undefined') {
                fieldValue.push(eventValue.value);
              }
            }
          }
        }
        return fieldValue;
      default:
        return fieldValue;
    }
  }

  /**
   * to get the task list
   * @param { int, int, string }
   */
  fetchList = (offset, listSize, years, activityIds, fieldIds, cuts, seasons) => {
    const { activeFarm, getTaskList, taskList } = this.props;

    getTaskList(
      activeFarm.farm.id,
      offset,
      listSize,
      activityIds,
      fieldIds,
      years,
      cuts,
      seasons
    );
  };

  /**
   * Get sort option list
   * @returns {array}
   */
  getSortByOptions = () => {
    const { intl } = this.props;
    return TaskSortingOptions.map(option => ({
      value: option.value,
      label: intl.formatMessage({ id: option.label })
    }));
  };

  /**
   * To clear the selected task items
   * @param { boolean } optional
   *  */

  clearSelection = clear => {
    const { clearSelection } = this.state;
    if (clearSelection || clear) {
      this.setState({
        checkedItems: new Map(),
        assignee: '',
        selectedAssigneeData: {},
        clearSelection: false,
        hasCompletedTask: false
      });
    }
  };

  selectSelection = () => {
    const { taskList } = this.props;
    if (taskList && taskList.data) {
      //eslint-disable-next-line
      taskList.data.map(taskItem => {
        this.setState(prevState => ({ checkedItems: prevState.checkedItems.set(taskItem.id, true) }));
      });
    }
  }

  /**
   * update permission check
   */
  updatePermission = () => {
    const { activeFarm, rolesDetails } = this.props;
    this.setState({
      hasPermission: {
        deletetask: checkPermissions(DELETE_TASK, activeFarm, rolesDetails),
        updateTask: checkPermissions(UPDATE_TASK, activeFarm, rolesDetails),
        createTask: checkPermissions(CREATE_TASKS, activeFarm, rolesDetails)
      }
    });
  };

  // To get the selected task items from the list
  getSelectedTask = values => new Map([...values].filter(([k, v]) => v === true));

  // Check or un-check the task item
  handleCheckbox = e => {
    const item = e.target.id;
    const isChecked = e.target.checked;
    this.setState(prevState => ({ checkedItems: prevState.checkedItems.set(item, isChecked) }));
  };

  /**
   * List the assigne in the dropdown
   * @returns {array} dropdown options
   */
  assigneeOptions = () => {
    const { assignees, profilePictures } = this.props;
    if (assignees.users) {
      return assignees.users.map(data => {
        const userImage = _.find(profilePictures, ['userId', data.user.id]);
        return {
          value: data.user.id,
          label: [
            <span className="user-name">{data.user.firstName}</span>,
            <ProfileImage size="dropdown-image" imgUrl={userImage ? userImage.image : null} />
          ]
        };
      });
    }
    return [];
  };

  /**
   * To get selected task object
   * @returns { Object }
   */
  getSelectedTaskDetails = () => {
    const { taskList } = this.props;
    const { checkedItems } = this.state;
    const selectedItem = this.getSelectedTask(checkedItems);
    const selectedtaskObj = [];
    selectedItem.forEach((v, k) => selectedtaskObj.push(_.filter(taskList.data, ['id', k])[0]));
    return selectedtaskObj;
  };

  /**
   * to delete tasks
   * @param {boolean} action
   */
  deleteTaskItems = (action) => {
    if (!action) {
      this.setState({
        deleteConfirmShow: false,
        deleteTaskState: false,
        selectedItems: [],
        isBottomSheetVisible: false,
        isModalOpen: false,
        selectAll: false
      });
      return;
    }

    const { deleteSelectedTasks, activeFarm } = this.props;
    const { selectedItems } = this.state;

    const task = this.filterValueList("task") || [];
    const field = this.filterValueList("field") || [];
    const cut = this.filterValueList("cut") || [];
    const season = this.filterValueList("season") || [];
    const year = (this.filterValueList("year") && this.filterValueList("year").length > 0) ? this.filterValueList("year") : 9999;
    const noFiltersApplied =
      year.length === 0 &&
      task.length === 0 &&
      field.length === 0 &&
      cut.length === 0 &&
      season.length === 0;
    let taskIdsToExport = [];
    if (!noFiltersApplied && selectedItems.length > 0 && !this.isAllSelected()) {
      taskIdsToExport = selectedItems;
    }

    if (action && selectedItems.length > 0) {
      const itemsToDeleteCount = selectedItems.length;
      let singleDeletedActivityId = null;

      if (itemsToDeleteCount === 1) {
        const deletedTask = this.props.taskList.data.find(task => task.id === selectedItems[0]);
        if (deletedTask) {
          singleDeletedActivityId = deletedTask.activityId;
        }
      }
      this.setState({
        selectedItemsCountForSnackbar: itemsToDeleteCount,
        singleDeletedActivityIdForSnackbar: singleDeletedActivityId,
      }, () => {
        deleteSelectedTasks(activeFarm.farm.id, task, field, year, cut, season, taskIdsToExport);

        this.clearSelection(true);
        this.setState({
          deleteConfirmShow: false,
          deleteTaskState: false,
          selectedItems: [],
          isBottomSheetVisible: false,
          isModalOpen: false,
          selectAll: false
        });
      });
    }
  };

  // On change of assignee dropdown
  onAssigneeChange = assignee => {
    const { assignees } = this.props;
    const selectedTasks = this.getSelectedTaskDetails();
    const completedtask = _.filter(selectedTasks, ['status', COMPLETED]);
    if (completedtask.length === selectedTasks.length) {
      this.setState(prevState => ({
        hasCompletedTask: true,
        assignOnlyCompletedTask: !prevState.assignOnlyCompletedTask
      }));
    } else {
      this.setState(prevState => ({
        assignee,
        assigeUpdateConfirm: !prevState.assigeUpdateConfirm,
        selectedAssigneeData: _.filter(assignees.users, ['user.id', assignee.value])[0].user,
        hasCompletedTask: completedtask.length > 0,
        clearSelection: true
      }));
    }
  };

  // On click of completed button
  completeSelectedTask = () => {
    const { selectedTaskCompleted, activeFarm } = this.props;
    const selectedTasks = this.getSelectedTaskDetails();
    const taskList = [];
    selectedTasks.map(task => (
      taskList.push(task.id)
    ));
    selectedTaskCompleted(activeFarm.farm.id, taskList);
    this.setState({
      completedTaskState: false
    });
  };

  /**
   * On change of sort by dropdown
   * @param {object}
   */
  onChangeSortby = sortBy => {
    const { sortyByOption, taskList } = this.props;
    sortyByOption(sortBy);
    const fieldValue = this.filterValueList("field");
    const taskValue = this.filterValueList("task");
    const yearValue = this.filterValueList("year");
    const cutValue = this.filterValueList("cut");
    const seasonValue = this.filterValueList("season");
    this.fetchList(0, 15, taskList.taskPeriod, taskValue, fieldValue, yearValue, cutValue, seasonValue);
  };

  /**
   * on change of choose period dropdown
   * @param {number} days
   */
  onChangePeriod = (yearsArray) => { // Renamed 'years' to 'yearsArray' for clarity
    const { taskList, periodOption } = this.props;

    // Dispatch the array directly to your Redux store
    periodOption(yearsArray); // This will store the array (e.g., ['2025']) in Redux

    const fieldValue = this.filterValueList("field");
    const taskValue = this.filterValueList("task");
    const cutValue = this.filterValueList("cut");
    const seasonValue = this.filterValueList("season");
    const yearsForApi = this.filterValueList("year");

    this.fetchList(
      0,
      15,
      yearsForApi,
      taskValue,
      fieldValue,
      cutValue,
      seasonValue
    );
  };

  /**
   * To fetch more task
   * Void
   */
  fetchMoreTask = () => {
    const { taskList } = this.props;
    const { isLoading, isDeleteLoading, data, paginationDetails } = taskList;

    // Get filter values (as you already do)
    const fieldValue = this.filterValueList("field");
    const taskValue = this.filterValueList("task");
    const yearValue = (this.filterValueList("year") && this.filterValueList("year").length > 0)
      ? this.filterValueList("year")
      : 9999;
    const cutValue = this.filterValueList("cut");
    const seasonValue = this.filterValueList("season");

    const totalFilteredCount = paginationDetails?.listTaskCount || 0; // Default to 0 if not available
    const currentDataCount = data?.length || 0; // Default to 0

    const hasMore = currentDataCount < totalFilteredCount;

    // Only proceed if not already loading, not deleting, there's data, and more data exists
    if (!isLoading && !isDeleteLoading && currentDataCount > 0 && hasMore) {
      this.setState({ clearSelection: false });
      // Assume fetchList sets isLoading to true internally or via an action
      this.fetchList(currentDataCount, 15, yearValue, taskValue, fieldValue, cutValue, seasonValue);
    }
  };

  /**
    * filter based on field selection
    * @param {*} e 
    */
  handleFilterFieldChange = (selectedValueArray) => {
    const valueObjects = selectedValueArray.map(value => ({ value }));
    SetSessionData(FILTER_TASK_FIELD, valueObjects);
    this.setState({ filterChange: true });
  }

  /**
   * filter based on task selection
   * @param {*} e 
   */
  handleFilterTaskChange = (selectedValueArray) => {
    const valueObjects = selectedValueArray.map(value => ({ value }));
    SetSessionData(FILTER_TASK_ACTIVITY, valueObjects);
    const enabledSeasonActivityIds = ["act7", "act30", "act31", "act32"];
    const enabledCutActivityIds = ["act11", "act12", "act16", "act9", "act10", "act28", "act14", "act5", "act15", "act18", "act17"];
    const areSeasonEnablingActivitiesSelected = selectedValueArray.some(id =>
      enabledSeasonActivityIds.includes(id)
    );
    const areCutEnablingActivitiesSelected = selectedValueArray.some(id =>
      enabledCutActivityIds.includes(id)
    );
    const currentCutFilter = GetSessionData(FILTER_TASK_CUT);
    const currentSeasonFilter = GetSessionData(FILTER_TASK_SEASON);
    if (selectedValueArray.length === 0 || (!areCutEnablingActivitiesSelected && currentCutFilter && Array.isArray(currentCutFilter) && currentCutFilter.length > 0)) {
      SetSessionData(FILTER_TASK_CUT, []);
    }
    if (selectedValueArray.length === 0 || (!areSeasonEnablingActivitiesSelected && currentSeasonFilter && Array.isArray(currentSeasonFilter) && currentSeasonFilter.length > 0)) {
      SetSessionData(FILTER_TASK_SEASON, []);
    }
    this.setState({ filterChange: true });
  };

  handleFilterCutChange = (selectedValueArray) => {
    const valueObjects = selectedValueArray.map(value => ({ value }));
    SetSessionData(FILTER_TASK_CUT, valueObjects);
    this.setState({ filterChange: true });
  };

  handleFilterSeasonChange = (selectedValueArray) => {
    const valueObjects = selectedValueArray.map(value => ({ value }));
    SetSessionData(FILTER_TASK_SEASON, valueObjects);
    this.setState({ filterChange: true });
  };

  handleFilterYearChange = (selectedValueArray) => {
    const valueObjects = selectedValueArray.map(value => ({ value }));
    SetSessionData(FILTER_TASK_YEAR, valueObjects);
    this.setState({ filterChange: true });
  };

  /**
   * reset the filter
   * @param {*} e 
   */
  resetFilter() {
    const { periodOption, sortyByOption } = this.props;
    sessionStorage.removeItem(FILTER_TASK_FIELD);
    sessionStorage.removeItem(FILTER_TASK_ACTIVITY);
    sessionStorage.removeItem(FILTER_TASK_YEAR);
    sessionStorage.removeItem(FILTER_TASK_CUT);
    sessionStorage.removeItem(FILTER_TASK_SEASON);
    periodOption(null);
    sortyByOption(
      {
        value: 'Date created',
        label: <FormattedMessage id="DATE_CREATED" />
      }
    );
    this.setState({ resetFilter: true, filterChange: true });
  }

  /**
   * Update assignee on confirmation
   * @param {boolean} action
   */

  updateTaskAssignee = action => {
    const { updateAssignee } = this.props;
    const { selectedAssigneeData } = this.state;
    if (action) {
      let selectedTasks = this.getSelectedTaskDetails();
      _.remove(selectedTasks, task => task.status === COMPLETED);
      selectedTasks = selectedTasks.map(task => {
        const taskUpdateAssignee = task;
        taskUpdateAssignee.assignee = selectedAssigneeData;
        return taskUpdateAssignee;
      });
      updateAssignee(selectedTasks, 'assign');
    } else {
      this.setState({
        assignee: ''
      });
    }
    this.setState(prevState => ({ assigeUpdateConfirm: !prevState.assigeUpdateConfirm }));
  };

  /**
   * Assignee confimation boby content
   * @param {array} selectedtask
   * @returns { HTMLElement }
   */
  getAssigneeConfirmMsg = selectedCount => {
    const { selectedAssigneeData, hasCompletedTask } = this.state;
    const { intl } = this.props;
    return `<div class="confirm-msg-wrapper"> 
        <p>${intl.formatMessage({
      id: 'ASSIGN_TASK_TEXT_1'
    })} ${selectedCount} ${intl.formatMessage({ id: 'ASSIGN_TASK_TEXT_2' })} ${selectedAssigneeData.firstName
      } ${selectedAssigneeData.lastName}</p>
        ${hasCompletedTask ? `<p>${intl.formatMessage({ id: 'ASSIGN_TASK_TEXT_3' })}</p>` : ''}
      </div>`;
  };

  /**
   * Assignee confimation boby content
   * @param {array} selectedtask
   * @returns { HTMLElement }
   */
  getDeleteConfirmMsg = selectedCount => {
    const { intl } = this.props;
    return `<div class="confirm-msg-wrapper"> 
        <p>${selectedCount} ${intl.formatMessage({ id: 'DELETE_TASK_TEXT_1' })} </p>
      </div>`;
  };

  clearDeleteFlag = () => {
    const { clearDeleteSucess } = this.props;
    clearDeleteSucess(false);
  };

  /**
   * Grouping the tasks items
   * @returns {object}
   */
  getSortByValue = () => {
    const { taskList } = this.props;
    switch (taskList.sortBy.value) {
      case 'Date created':
        return {
          type: 'createdTimestamp',
          data: taskList.data
        };
      case 'field':
        return { type: 'field', data: _.groupBy(taskList.data, 'fieldName') };
      case 'activity':
        return { type: 'activity', data: _.groupBy(taskList.data, 'activityName') };
      case 'user':
        return { type: 'assignee', data: _.groupBy(taskList.data, 'assigneeFirstName') };
      case 'status':
        return {
          type: 'status',
          data: _.groupBy(taskList.data, value => value.status.toUpperCase())
        };
      default:
        return {
          type: 'createdTimestamp',
          data: taskList.data
        };
    }
  };

  /**
   *  to get the title of sortby value
   * @param {string} value
   * @returns {string}
   */
  getSortbyName = value => {
    const { taskList } = this.props;
    switch (taskList.sortBy.value) {
      case 'activity':
        if (value.toUpperCase() === UNDEFINED) {
          return <FormattedMessage id="NOT_DEFINED" />;
        }
        return <FormattedMessage id={ActivityTranslation(value)} />;
      case 'user':
        if (value.toUpperCase() === UNDEFINED) {
          return <FormattedMessage id="PLANNED" />;
        }
        return value.toLowerCase();
      case 'field':
        if (value.toUpperCase() === UNDEFINED) {
          return <FormattedMessage id="NOT_DEFINED" />;
        }
        return value.toLowerCase();
      default:
        return value.toLowerCase();
    }
  };

  /**
   * to get task cost in the group
   */
  getTaskCount = (groupBy, groupObject) => {
    const { taskList } = this.props;
    switch (groupBy) {
      case 'field':
        return groupObject.field
          ? taskList.paginationDetails.sortFieldMap[groupObject.field.fieldId]
          : taskList.paginationDetails.sortFieldMap[UNDEFINED.toLowerCase()];
      case 'activity':
        return groupObject.activity
          ? taskList.paginationDetails.sortFieldMap[groupObject.activity.id]
          : taskList.paginationDetails.sortFieldMap[UNDEFINED.toLowerCase()];
      case 'assignee':
        return groupObject.assignee
          ? taskList.paginationDetails.sortFieldMap[groupObject.assignee.id]
          : null;
      case 'status':
        return taskList.paginationDetails.sortFieldMap[groupObject.status];
      default:
        return null;
    }
  };

  displayingFilter = () => {
    this.setState(prevState => ({
      displayFilter: !prevState.displayFilter,
      fetchTaskDetails: true
    }));
  };

  handleOpenNewAddTaskModalWindow = () => {
    this.setState(prevState => ({
      openNewAddTaskModalWindow: true, // This will open NewAddTaskModal
      // editTask: false
    }));
  }

  handleCloseNewAddTaskModalWindow = () => {
    this.setState({
      openNewAddTaskModalWindow: false,
      // editTask: false,
    });
  };

  handleOpenModalWindow = (taskId) => {
    const { taskList } = this.props;
    const filteredTasks = taskList.data.filter(
      task => task.id === taskId
    );

    this.setState(prevState => ({
      editTask: true, // This will open your AddTaskModal
      filteredTask: filteredTasks[0]
    }));
  }

  handleCloseModalWindow = () => {
    this.setState(prevState => ({
      editTask: false,
      filteredTask: []
    }));
  }

  handleSave = (activityId, fieldId, activityName, fieldName) => {
    this.setState({
      selectedActivityId: activityId,
      selectedFieldId: fieldId,
      selectedActivityName: activityName,
      selectedFieldName: fieldName,
      openNewAddTaskModalWindow: false,
      editTask: true,
    });
  };

  /**
   * To render the task item list
   * @returns {array} task list component
   */
  renderList = () => {
    const { taskList, intl, taskDetails } = this.props;
    const { hasPermission, selectedItems } = this.state;
    const { isLoading, isDeleteLoading } = taskList;
    if (taskList.data && taskList.data.length > 0) {
      const sortedData = this.getSortByValue();
      if (taskList.sortBy.value === 'Date created') {
        return (
          <ul className="task-list-wrapper full-width">
            {sortedData.data.map(item => (
              <TaskListItem
                TaskDetails={item}
                intl={intl}
                handleCheckbox={this.handleItemCheckboxToggle}
                checked={selectedItems.includes(item.id)}
                key={item.id}
                isLoading={isLoading || isDeleteLoading}
                hasPermission={hasPermission}
                handleOpenModalWindow={this.handleOpenModalWindow}
              />
            ))}
          </ul>
        );
      }
    }
    return null;
  };

  createTaskButton = () => {
    const { history, userDetails } = this.props;
    const { taskListFields } = this.state;
    mixpanel.identify(userDetails.id);
    mixpanel.track(ADD_TASK);
    if (taskListFields.length > 0) {
      this.setState({
        show: false
      });
      history.push("/tasks/tasklist/create");
    } else {
      this.setState({
        show: true
      });
    }
  }

  cancelDialog = () => {
    this.setState({
      show: false
    });
  }

  redirectDialog = () => {
    const { history, userDetails } = this.props;
    mixpanel.identify(userDetails.id);
    mixpanel.track(ADD_FIELD);
    this.setState({
      show: false
    });
    history.push("/managefields/new");
  }

  updatePanelPosition = () => {
    if (this.tabPanelRef.current) {
      const rect = this.tabPanelRef.current.getBoundingClientRect();
      this.setState({
        panelLeft: rect.left,
        panelWidth: rect.width
      });
    }
  };

  handleHeaderCheckboxChange = (event) => {
    const { taskList } = this.props;
    const isChecked = event.target.checked;
    if (isChecked) {
      const allIds = taskList.data.map(item => item.id);
      if(allIds.length > 0) {
        this.setState((prevState) => ({
          selectedItems: [...new Set([...prevState.selectedItems, ...allIds])],
          isBottomSheetVisible: true,
          selectAll: true,
        }));
      }
    } else {
      this.setState({
        selectedItems: [],
        isBottomSheetVisible: false,
        selectAll: false,
      });
    }
  };

  isAllSelected = () => {
    const { taskList } = this.props;
    const { selectedItems } = this.state;
    const visibleIds = taskList.data.map(item => item.id);
    return visibleIds.length > 0 && visibleIds.every(id => selectedItems.includes(id));
  };

  isIndeterminate = () => {
    const { taskList } = this.props;
    const { selectedItems } = this.state;
    const visibleIds = taskList.data.map(item => item.id);
    return (
      selectedItems.length > 0 &&
      !visibleIds.every(id => selectedItems.includes(id)) &&
      visibleIds.some(id => selectedItems.includes(id))
    );
  };

  handleItemCheckboxToggle = (e, id) => {
    const isChecked = e.target.checked;

    this.setState((prevState) => {
      const updatedSelectedItems = isChecked
        ? [...prevState.selectedItems, id]
        : prevState.selectedItems.filter((itemId) => itemId !== id);

      return {
        selectedItems: updatedSelectedItems,
        isBottomSheetVisible: updatedSelectedItems.length > 0,
        selectAll: isChecked ? prevState.selectAll : false,
      };
    });
  };

  handleCloseBottomSheet = () => {
    this.setState({
      isBottomSheetVisible: false,
      selectedItems: [],
    });
  };

  getActivityOptions = () => {
    const { taskList } = this.props;
    const activityList = taskList?.paginationDetails?.activities;

    if (!Array.isArray(activityList)) return [];

    const activityOptions = activityList.map(activity => ({
      label: activity.activityName,
      value: activity.id,
    }));

    return activityOptions;
  };

  getFieldListOptions = () => {
    const { taskList } = this.props;

    return taskList?.paginationDetails?.fields?.map(field => ({
      label: field.name,
      value: field.id,
    })) || [];
  };

  getYearDropdownOptions = () => {
    const { taskList } = this.props;
    const yearList = taskList?.paginationDetails?.years;

    if (!Array.isArray(yearList)) return [];

    const yearOptions = yearList.map(year => ({
      label: year.toString(),
      value: year
    }));

    return yearOptions;
  };

  getCutDropdownOptions = () => {
    const { taskList } = this.props;
    const cutsList = taskList?.paginationDetails?.cuts;

    if (!Array.isArray(cutsList)) return [];

    const cutOptions = cutsList.map(cut => {
      const match = cut.match(/^(\d+)/);
      const cutNumber = match ? match[1] : '';

      return {
        label: cut,
        value: cutNumber
      };
    });

    return cutOptions;
  };

  getSeasonDropdownOptions = () => {
    const { taskList } = this.props;
    const seasonsList = taskList?.paginationDetails?.seasons;

    if (!Array.isArray(seasonsList)) return [];

    const seasonOptions = seasonsList.map((season, index) => ({
      label: season,
      value: index + 1
    }));

    return seasonOptions;
  };

  handleSnackbarClose = () => {
    this.setState({
      showSnackBar: false,
      snackbarMessage: '', // Reset the message after close
    });
  };

  showSnackbar = (message) => {
    this.setState({
      showSnackBar: true,
      snackbarMessage: message,
    });
  };

  render() {
    const { taskList, intl, exportTasks, activeFarm, reportDetails, userDetails, fieldDetails, activitiesCommon, userActivities } = this.props;
    const { isReportLoading } = reportDetails;
    const {
      deleteConfirmShow,
      assignOnlyCompletedTask,
      hasPermission,
      show,
      panelLeft,
      panelWidth,
      showSnackBar,
      isModalOpen
    } = this.state;
    const {
      isLoading,
      isDeleteLoading,
      data,
      paginationDetails,
      deleteSuccess,
      taskPeriod
    } = taskList;
    const inputStyle = { fontFamily: 'Inter', fontWeight: 500, fontSize: '14px', width: '340px' };
    const titleFont = {
      color: '#191C1C',
      textAlign: 'center',
      fontFamily: 'Inter',
      fontSize: '24px',
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: '32px'
    }
    const subTitleFont = {
      color: '#3F4949',
      textAlign: 'center',
      fontFamily: 'Inter',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: '20px',
      letterSpacing: '0.25px'
    }
    // const selectedCount = this.getSelectedTask(checkedItems).size;
    const activityListOptions = this.getActivityOptions();
    const fieldListOptions = this.getFieldListOptions();
    const yearlistOptions = this.getYearDropdownOptions();
    const cutListOptions = this.getCutDropdownOptions();
    const seasonListOptions = this.getSeasonDropdownOptions();
    const selectedActivityIds = this.filterValueList("task") || [];
    const enabledSeasonActivityIds = ["act7", "act30", "act31", "act32"];
    const enabledCutActivityIds = ["act11", "act12", "act16", "act9", "act10", "act28", "act14", "act5", "act15", "act18", "act17"];
    const showCut = selectedActivityIds.some(id => enabledCutActivityIds.includes(id));
    const showSeason = selectedActivityIds.some(id => enabledSeasonActivityIds.includes(id));
    const selectedCount = this.state.selectedItems.length;

    const AddNewFieldIcon = createSvgIcon(
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
            <path d="M20 13.5H13V20.5H11V13.5H4V11.5H11V4.5H13V11.5H20V13.5Z" fill="#002021" />
          </svg>
        </g>
      </svg>,
      'AddNewFieldIcon',
    );
    return (
      <div>
        <div className={`full-width ${isMobileOnly ? 'main-content-mobile' : 'main-content'}`} style={{
          backgroundColor: "#ffffff",
          height: (data?.length === 0 && paginationDetails && paginationDetails.listTaskCount === 0) ? 'auto' : '100vh',
          // height: '100vh',
          overflow: 'hidden', // Prevent outer scroll
          display: 'flex',
          flexDirection: 'column',
          paddingTop: '24px'
        }}>
          <div ref={this.tabPanelRef} style={{ position: 'relative', height: '100%', display: 'flex', flexDirection: 'column', overflowY: 'auto', paddingBottom: '60px' }}> {/* Add overflowY: 'auto' here */}
            {paginationDetails && paginationDetails.listTaskCount > 0 && (
              <>
                {/* HEADER AND FILTERS (NOW POSITION: STICKY) */}
                <div
                  style={{
                    width: panelWidth,
                    padding: '16px 0px 0px 0px',
                    backgroundColor: '#fff',
                    zIndex: 10,
                    flexShrink: 0,
                    position: 'fixed',
                    left: panelLeft,
                    pointerEvents: 'auto'
                  }}
                >
                  <Box sx={{ padding: '16px', overflowX: 'auto' }}>
                    <Stack direction="row" spacing={2} sx={{ alignItems: 'center' }}>
                      <MuiMultiSelectBottomSheet
                        label={intl.formatMessage({ id: 'ACTIVITY_REGISTERATION' })}
                        subTitle={intl.formatMessage({ id: 'REGISTRATION' })}
                        options={activityListOptions}
                        onChange={this.handleFilterTaskChange}
                        value={this.filterValueList("task")}
                        disableHelperText={true}
                        minWidthValue={150}
                      />

                      <MuiMultiSelectBottomSheet
                        label={intl.formatMessage({ id: 'FIELD_SELECTION' })}
                        subTitle={intl.formatMessage({ id: 'FIELD_SELECTION' })}
                        options={fieldListOptions}
                        onChange={this.handleFilterFieldChange}
                        value={this.filterValueList("field")}
                        disableHelperText={true}
                        minWidthValue={115}
                      />

                      <MuiMultiSelectBottomSheet
                        label={intl.formatMessage({ id: 'TASK_HARVEST' })}
                        subTitle={intl.formatMessage({ id: 'CT_CUT' })}
                        options={cutListOptions}
                        value={this.filterValueList("cut")}
                        onChange={this.handleFilterCutChange}
                        disabled={!showCut}
                        disableHelperText={true}
                        minWidthValue={120}
                      />

                      <MuiMultiSelectBottomSheet
                        label={intl.formatMessage({ id: 'CT_SEASON' })}
                        subTitle={intl.formatMessage({ id: 'CT_SEASON' })}
                        options={seasonListOptions}
                        value={this.filterValueList("season")}
                        onChange={this.handleFilterSeasonChange}
                        disabled={!showSeason}
                        disableHelperText={true}
                        minWidthValue={118}
                      />

                      <Box sx={{ paddingRight: '16px' }}>
                        <MuiMultiSelectListBottomSheet
                          subTitle={intl.formatMessage({ id: 'YEAR' })}
                          defaultValue={taskList?.paginationDetails?.years[0]}
                          options={yearlistOptions}
                          onChange={this.handleFilterYearChange}
                          value={this.filterValueList("year")}
                          disableHelperText={true}
                        />
                      </Box>
                    </Stack>
                  </Box>
                  <Box sx={{ mt: 2, paddingLeft: '16px' }}>
                    {paginationDetails && paginationDetails.totalTaskCount
                      ? `${paginationDetails.totalTaskCount} ${intl.formatMessage({ id: 'TASKS' })}`
                      : `0 ${intl.formatMessage({ id: 'TASKS' })}`
                    }
                  </Box>
                  <List style={{ height: '72px' }}>
                    <ListItem
                      style={{
                        padding: '0px',
                        height: '72px',
                        background: '#fff',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'stretch',
                        boxSizing: 'border-box',
                      }}
                    >
                      <Box
                        sx={{
                          flex: 1,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          padding: '0px 24px 0px 16px',
                          width: '100%',
                          boxSizing: 'border-box',
                        }}
                      >
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <Box
                            sx={{
                              width: '40px',
                              flexShrink: 0,
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}
                          >
                            <Checkbox
                              checked={this.isAllSelected()}
                              indeterminate={this.isIndeterminate()}
                              onChange={this.handleHeaderCheckboxChange}
                              sx={{
                                color: '#000',
                                '&.Mui-checked': { color: '#00696D' },
                                '&.MuiCheckbox-indeterminate': { color: '#00696D' },
                                flexShrink: 0,
                              }}
                            />
                          </Box>
                          <Typography
                            sx={{
                              color: '#191C1C',
                              fontSize: 14,
                              fontFamily: 'Inter',
                              fontWeight: 600,
                              paddingLeft: '16px',
                            }}
                          >
                            {intl.formatMessage({ id: 'ACTIVITY_REGISTERATION' })}
                          </Typography>
                        </Box>
                        <Typography
                          sx={{
                            whiteSpace: 'nowrap',
                            color: '#3F4949',
                            fontSize: 11,
                            fontFamily: 'Inter',
                            fontWeight: 500,
                          }}
                        >
                          {intl.formatMessage({ id: 'FIELD_NAME' })}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          height: '1px',
                          width: '100%',
                          backgroundColor: '#fff',
                        }}
                      >
                        <Box
                          sx={{
                            marginLeft: '16px',
                            marginRight: '24px',
                            height: '1px',
                            backgroundColor: '#BEC8C9',
                          }}
                        />
                      </Box>
                    </ListItem>
                  </List>
                </div>

                {/* SCROLLABLE CONTENT AREA */}
                <div
                  style={{
                    flex: 1, // This makes it take up all remaining vertical space
                    // overflowY: 'auto', // Removed: The parent `tabPanelRef` now handles scrolling
                    paddingTop: '205px'
                  }}
                >
                  {isLoading || isDeleteLoading ? (
                    <Loader styleName="center-align task-list-loader" />
                  ) : null}
                  {this.renderList()}
                  {taskList?.data?.length > 0 &&
                    (taskList.isLoading || taskList.isDeleteLoading) &&
                    taskList.data.length < taskList.paginationDetails?.listTaskCount && (
                      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '16px', width: '100%' }}>
                        <CircularProgress size={50} sx={{ color: '#00696D' }} />
                      </Box>
                    )}
                </div>
                {this.state.isBottomSheetVisible && (
                  <BottomSheet
                    selectedCount={this.state.selectAll ? paginationDetails.totalTaskCount : selectedCount}
                    onClose={this.handleCloseBottomSheet}
                    isExporting={this.state.isExporting}
                    onDelete={() => {
                      this.setState({
                        isModalOpen: true,
                        isBottomSheetVisible: false,
                      });
                    }}
                    onExport={() => {
                      const {
                        activeFarm,
                        taskList: { data, sortBy },
                      } = this.props;
                      const { selectedItems } = this.state;
                      const year = (this.filterValueList("year") && this.filterValueList("year").length > 0) ? this.filterValueList("year") : 9999;
                      if (!isReportLoading) {
                        this.setState({ isExporting: true });
                        const task = this.filterValueList("task") || [];
                        const field = this.filterValueList("field") || [];
                        const cut = this.filterValueList("cut") || [];
                        const season = this.filterValueList("season") || [];
                        const noFiltersApplied =
                          year.length === 0 &&
                          task.length === 0 &&
                          field.length === 0 &&
                          cut.length === 0 &&
                          season.length === 0;
                        let taskIdsToExport = [];
                        if (!noFiltersApplied && selectedItems.length > 0 && !this.isAllSelected()) {
                          taskIdsToExport = selectedItems;
                        }
                        exportTasks(
                          activeFarm,
                          year,
                          task,
                          field,
                          cut,
                          season,
                          taskIdsToExport
                        )
                          .then(() => this.setState({ isExporting: false, isBottomSheetVisible: false, selectedItems: [] }))
                          .catch(() => this.setState({ isExporting: false }));
                      }
                    }}
                    data={taskList.data}
                    selectedItems={this.state.selectedItems}
                  />
                )}

                {!this.state.isBottomSheetVisible && (
                  (hasPermission.createTask && paginationDetails && paginationDetails.totalTaskCount > 0) ? (
                    <Box
                      sx={{
                        position: 'fixed',
                        bottom: '110px',
                        right: '16px',
                        zIndex: 12,
                        transform: 'translateY(0)',
                      }}
                    >
                      <Fab
                        variant="extended"
                        onClick={() => {
                          mixpanel.identify(userDetails.id);
                          mixpanel.track(ADD_TASK);
                          this.handleOpenNewAddTaskModalWindow();
                        }}
                        disableRipple
                        sx={{
                          height: "56px",
                          borderRadius: '16px',
                          background: 'var(--M3-sys-light-primary-container, #6FF6FD)',
                          boxShadow: '0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px 0px rgba(0, 0, 0, 0.30)',
                          padding: '16px 20px',
                          display: 'flex',
                          alignItems: 'center',
                          '&:active': {
                            background: 'var(--M3-sys-light-primary-container, #6FF6FD)',
                            boxShadow: '0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px 0px rgba(0, 0, 0, 0.30)',
                          },
                        }}
                      >
                        <AddNewFieldIcon style={{ marginRight: '12px' }} />
                        <Typography style={{ textTransform: 'none', ...fieldListStyle.addButtonTextStyle }}>
                          {this.props.intl.formatMessage({ id: 'NEW_TASK_REGISTRATION' })}
                        </Typography>
                      </Fab>
                    </Box>
                  ) : null
                )}
              </>
            )}
          </div>
          {data?.length === 0 && paginationDetails && paginationDetails.listTaskCount === 0 && (
            <div className="manageFarmsLayout">
              <div className="manageFarmsLayoutDivLayout" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '50vh' }}>
                <div className="manageFarmsLayoutDiv">
                  <div><img src="images/NoTasks.png" alt="No Tasks" width="105" /></div>
                  <Box style={inputStyle}>
                    <Stack className="text-with-padding">
                      <div style={titleFont}>
                        {intl.formatMessage({ id: 'TASKS' })}
                      </div>
                    </Stack>
                    <Stack className="text-with-padding">
                      <div style={subTitleFont}>
                        {intl.formatMessage({ id: 'NO_TASKS_CONTENT' })}
                      </div>
                    </Stack>
                    <div style={{ padding: '20px 0px', paddingRight: '0px !important' }}>
                      <Stack direction="row" justifyContent="center">
                        <Chip
                          icon={<PlusIcon />}
                          label={intl.formatMessage({ id: 'TASKS_ADD' })}
                          color="primary"
                          variant="outlined"
                          clickable
                          className={`${!hasPermission.createTask ? 'disable' : ''}`}
                          onClick={() => {
                            mixpanel.identify(userDetails.id);
                            mixpanel.track(ADD_TASK);
                            this.handleOpenNewAddTaskModalWindow();
                          }}
                          style={buttonRoundStyle}
                        />
                      </Stack>
                    </div>
                  </Box>
                </div>
              </div>
            </div>
          )}
          {deleteSuccess && this.clearDeleteFlag()}
          {
            isModalOpen && hasPermission.deletetask ? (
              <Box>
                <Dialog
                  onClose={() => { }}
                  open={isModalOpen}
                  PaperProps={{
                    style: {
                      backgroundColor: '#E6E9E8',
                      borderRadius: "28px",
                      width: "312px",
                      minWidth: "280px",
                      maxWidth: "312px",
                      maxHeight: '30vh',
                    }
                  }}
                >
                  {/* Title & Subtitle */}
                  <Box style={taskTemplateStyle.cancelModalBox}>
                    <Typography style={taskTemplateStyle.cancelModalTitle}>
                      {intl.formatMessage({ id: 'DELETE_TASK_TITLE' })} ({this.state.selectAll ? paginationDetails.totalTaskCount : this.state.selectedItems.length})
                    </Typography>
                    <Typography style={taskTemplateStyle.cancelModalSubTitle}>
                      {intl.formatMessage({ id: 'DELETE_TASK_BODY' })}
                    </Typography>
                  </Box>

                  {/* Action Buttons */}
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'flex-end', // align to right
                      gap: '8px',
                      padding: '24px 24px 24px 8px',
                    }}
                  >
                    {/* Cancel Button */}
                    <Chip
                      label={intl.formatMessage({ id: 'cancel' })}
                      clickable
                      style={{
                        fontFamily: 'Inter',
                        fontWeight: 500,
                        fontSize: 14,
                        color: '#00696D',
                        background: 'transparent',
                      }}
                      sx={{
                        backgroundColor: 'transparent',
                        '&:hover, &:focus': {
                          backgroundColor: 'transparent',
                        },
                        '.MuiChip-label': {
                          padding: 0,
                        },
                      }}
                      disableRipple
                      onClick={() => this.deleteTaskItems(false)}
                    />

                    {/* Delete Button */}
                    <Chip
                      label={
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <IconButton
                            sx={{ padding: '10px' }}
                            disabled={selectedCount === 0}
                          >
                            <img src="/images/DeleteIcon.svg" alt="Delete" />
                          </IconButton>
                          <Typography
                            sx={{
                              color: 'var(--M3-sys-light-error, #BA1A1A)',
                              fontFamily: 'Inter',
                              fontSize: '16px',
                              fontStyle: 'normal',
                              fontWeight: '400',
                              lineHeight: '24px',
                              letterSpacing: '0.5px',
                            }}
                          >
                            {intl.formatMessage({ id: 'DELETE_TEXT' })}
                          </Typography>
                        </Box>
                      }
                      clickable
                      style={taskTemplateStyle.cancelButtonStyle}
                      sx={{
                        backgroundColor: 'transparent',
                        '&:hover, &:focus': {
                          backgroundColor: 'transparent',
                        },
                        padding: 0,
                        '.MuiChip-label': {
                          padding: 0,
                        },
                      }}
                      disableRipple
                      onClick={this.deleteTaskItems}
                    />
                  </Box>
                </Dialog>
              </Box>
            ) : null
          }
          <ModalDialog
            show={assignOnlyCompletedTask}
            width={{ mobile: '200px', tablet: '200px', web: '200px' }}
            height={{ mobile: '300px', tablet: '300px', web: '300px' }}
            closeIcon=""
            onClose={() => { }}
          >
            <div className="completed-assign-msg">
              <AlertIcon scale={1.5} />
              <p>{intl.formatMessage({ id: 'ASSIGN_TASK_TEXT_3' })}</p>
              <ActionButton
                onClick={() =>
                  this.setState(prevState => ({
                    assignOnlyCompletedTask: !prevState.assignOnlyCompletedTask
                  }))
                }
              >
                {intl.formatMessage({ id: 'BACK' })}
              </ActionButton>
            </div>
          </ModalDialog>
          {show && (
            <Dialog open={show} onClose={() => { }} PaperProps={{
              style: {
                backgroundColor: '#E6E9E8',
                borderRadius: "28px",
                width: "320px",
                minWidth: "200px",
                maxWidth: "320px",
              }
            }}>
              <DialogTitle style={dialogTitleDialogStyle}>
                {intl.formatMessage({ id: 'TASK_BUTTON_NO_FIELD_HEADING' })}
              </DialogTitle>
              <Box component="div" style={dialogSubTitleStyle}>
                {intl.formatMessage({ id: 'TASK_BUTTON_NO_FIELD_CONTENT' })}
              </Box>
              <div style={{ padding: "15px", textAlign: "right" }}>
                <span>
                  <Chip
                    label={intl.formatMessage({ id: 'CANCEL' })}
                    clickable
                    style={buttonStyle}
                    sx={{
                      backgroundColor: 'transparent',
                      '&:hover, &:focus': {
                        backgroundColor: 'transparent',
                      }
                    }}
                    disableRipple
                    onClick={() => this.cancelDialog()}
                  />
                  <Chip
                    label={intl.formatMessage({ id: 'FV_AF' })}
                    clickable
                    style={buttonStyle}
                    sx={{
                      backgroundColor: 'transparent',
                      '&:hover, &:focus': {
                        backgroundColor: 'transparent',
                      }
                    }}
                    disableRipple
                    onClick={() => this.redirectDialog()}
                  />
                </span>
              </div>
            </Dialog>
          )}
        </div>
        <Snackbar
          open={showSnackBar}
          autoHideDuration={3000}
          onClose={this.handleSnackbarClose}
          message={this.state.snackbarMessage}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: '4px',
            width: '344px',
            padding: '14px 16px',
            minWidth: 'fit-content',
            marginBottom: '90px'
          }}
        />
        {
          this.state.editTask && (
            <EditTask
              editTask={this.state.editTask}
              onClose={() => this.setState({ editTask: false })} // Optionally clear them on close
              filteredTask={this.state.filteredTask}
              handleCloseModalWindow={this.handleCloseModalWindow}
              openNewAddTaskModalWindow={this.state.openNewAddTaskModalWindow}
              handleCloseNewAddTaskModalWindow={this.handleCloseNewAddTaskModalWindow}
              selectedActivityId={this.state.selectedActivityId}
              selectedFieldId={this.state.selectedFieldId}
              selectedActivityName={this.state.selectedActivityName}
              selectedFieldName={this.state.selectedFieldName}
            />
          )
        }
        <NewAddTaskModalWindow
          intl={intl}
          fieldDetails={fieldDetails}
          onCreateTask={this.state.openNewAddTaskModalWindow}
          userActivities={userActivities}
          closeNewTask={this.handleCloseNewAddTaskModalWindow}
          handleSave={this.handleSave}
        />
        {this.state.isExporting && (
          <Box
            sx={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              backgroundColor: 'rgba(128, 128, 128, 0.5)', // semi-transparent grey
              zIndex: 2000, // ensure it’s above everything else
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              pointerEvents: 'auto', // make it intercept all clicks
            }}
          >
            <CircularProgress size={60} sx={{ color: '#ffffff' }} />
          </Box>
        )}
      </div >
    );
  }
}

const mapStateToProps = state => ({
  userDetails: state.userDetails.data,
  taskDetails: state.taskDetails,
  rolesDetails: state.RolesDetails,
  activeFarm: state.farmList.activeFarm,
  taskList: state.TaskList,
  assignees: state.farmUserDetails.userList,
  profilePictures: state.profileImage.userImage,
  farmsData: state.farmList,
  reportDetails: state.reportDetails,
  activitiesCommon: state.masterData.data[0]?.activities,
  fieldDetails: state.fieldDetails,
  userActivities: state.userActivities
});

const mapDispatchToProps = dispatch => ({
  getTaskList: (farmId, offset, numberOfTasks, years, activityIds, fieldIds, cuts, seasons) =>
    dispatch(fetchTaskList(farmId, offset, numberOfTasks, years, activityIds, fieldIds, cuts, seasons)),
  fetchAssignee: (farmId, token) => dispatch(getUsers(farmId, token)),
  updateAssignee: (tasks, type) => dispatch(createUpdateTask(tasks, type)),
  deleteSelectedTasks: (farmId, activityIds, fieldIds, years, cuts, seasons, taskIds) => dispatch(deleteTasks(farmId, activityIds, fieldIds, years, cuts, seasons, taskIds)),
  clearDeleteSucess: data => dispatch(deleteInfoClear(data)),
  exportTasks: (farm, days, activityIds, fieldIds, cuts, seasons, taskIds) => dispatch(exportReport(farm, days, activityIds, fieldIds, cuts, seasons, taskIds)),
  periodOption: years => dispatch({ type: TASK_PERIOD_VALUE, taskPeriod: years }),
  selectedTaskCompleted: (farmId, data) => dispatch(selectedTaskCompleted(farmId, data)),
  fetchFieldList1: farmId => dispatch(fieldActions.fetchFieldList1(farmId)),
  getUserActivities: (farmId) => dispatch(getUserActivitiesAction.getUserActivities(farmId)),
});

export default injectIntl(
  reduxForm({
    form: 'ManageTask'
  })(withRouter(connect(mapStateToProps, mapDispatchToProps)(ManageTask)))
);
